// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ecc9608d","72":"c55421d2","160":"63095421","322":"1f3b1d60","325":"6c6e89f8","687":"78be3f4b","695":"089d5733","904":"0e6053c8"}[chunkId] + ".chunk.js";
};